import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsSatisfaction2Route: InvariantJiraRoute = {
	name: 'servicedesk-reports-satisfaction',
	path: '/jira/servicedesk/projects/:projectKey/reports/all-rating',
};
